let mockTimezoneOffset: number | undefined;

export function setMockTimezoneOffset(offset: number | undefined): void {
    mockTimezoneOffset = offset;
}

export function getTimezoneOffsetForDate(date: Date): number {
    return mockTimezoneOffset ?? date.getTimezoneOffset();
}
